import { IRequestContext } from '@msdyn365-commerce/core';
import { IVehicleType } from '../../defa-find-engine-heater';

export function getVehicleTypes(requestContext: IRequestContext): IVehicleType[] | undefined {
    let types: IVehicleType[] | undefined;

    try {
        // eslint-disable-next-line @typescript-eslint/no-require-imports, security/detect-non-literal-require
        types = require(`./${requestContext.locale}.json`);
    } catch {
        try {
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            types = require(`./en-us.json`);
        } catch {
            // Do nothing
        }
    }

    return types;
}
